import { forwardRef } from "react";
import { LucideProps } from "lucide-react";

/**
 * A playing court seen from above — centre line, centre circle and both goal
 * areas — drawn in lucide's outline style. lucide-react has no sports-hall icon
 * (its sports icons are balls, equipment and trophies), so this custom icon keeps
 * the sports-hall service card consistent with the other lucide service icons,
 * like `SupBoardIcon` does for SUP. Sport-neutral on purpose: it reads for a
 * hall court and an outdoor pitch alike (PO, 2026-10-20).
 */
const SportsCourtIcon = forwardRef<SVGSVGElement, LucideProps>(
    (
        { size = 24, color = "currentColor", strokeWidth = 2, absoluteStrokeWidth, className, ...rest },
        ref,
    ) => (
        <svg
            ref={ref}
            xmlns="http://www.w3.org/2000/svg"
            width={size}
            height={size}
            viewBox="0 0 24 24"
            fill="none"
            stroke={color}
            strokeWidth={
                absoluteStrokeWidth
                    ? (Number(strokeWidth) * 24) / Number(size)
                    : strokeWidth
            }
            strokeLinecap="round"
            strokeLinejoin="round"
            className={className}
            {...rest}
        >
            {/* court outline */}
            <rect x="2" y="5" width="20" height="14" rx="2" />
            {/* centre line */}
            <path d="M12 5v14" />
            {/* centre circle */}
            <circle cx="12" cy="12" r="2.5" />
            {/* goal areas */}
            <path d="M2 9.5h3v5H2" />
            <path d="M22 9.5h-3v5h3" />
        </svg>
    ),
);

SportsCourtIcon.displayName = "SportsCourtIcon";

export default SportsCourtIcon;
